import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { supervisorAPI } from '../../utils/api';
import { toast } from 'sonner';
import { LogIn, User, KeyRound } from 'lucide-react';

const SupervisorLogin = () => {
  const [supervisorId, setSupervisorId] = useState('');
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!supervisorId || !pin) {
      toast.error('Please enter both Supervisor ID and PIN');
      return;
    }

    setLoading(true);
    try {
      const response = await supervisorAPI.login(supervisorId, pin);
      login(response.data.token, 'supervisor', response.data.supervisor);
      toast.success('Login successful!');
      navigate('/supervisor/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-600 mb-4">
            <User className="w-10 h-10 text-white" strokeWidth={2.5} />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight uppercase" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
            PARK SUPERVISOR LOGIN
          </h1>
          <p className="text-sm font-medium tracking-wide uppercase text-slate-500 mt-2">
            Park Monitoring System
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="text-sm font-bold uppercase tracking-wider text-slate-700 mb-2 block">
              Supervisor ID
            </label>
            <div className="relative">
              <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
              <input
                type="text"
                value={supervisorId}
                onChange={(e) => setSupervisorId(e.target.value.toUpperCase())}
                className="h-14 pl-12 pr-4 w-full rounded-lg border-2 border-slate-300 focus:border-blue-600 focus:ring-0 text-lg bg-white"
                placeholder="ITS01"
                data-testid="supervisor-id-input"
              />
            </div>
          </div>

          <div>
            <label className="text-sm font-bold uppercase tracking-wider text-slate-700 mb-2 block">
              PIN
            </label>
            <div className="relative">
              <KeyRound className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
              <input
                type="password"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                className="h-14 pl-12 pr-4 w-full rounded-lg border-2 border-slate-300 focus:border-blue-600 focus:ring-0 text-lg bg-white"
                placeholder="Enter your PIN"
                maxLength="6"
                data-testid="supervisor-pin-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="h-14 w-full rounded-lg font-bold uppercase tracking-wide shadow-md hover:shadow-lg transition-all active:scale-95 text-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            data-testid="supervisor-login-button"
          >
            {loading ? (
              <div className="w-6 h-6 border-3 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <>
                <LogIn className="w-5 h-5" />
                LOGIN
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SupervisorLogin;
